<div>
  <router-outlet></router-outlet>

  <div id="iosButtonInstallApp" class="d-none" data-bs-toggle="modal" data-bs-target="#iosInstallApp"></div>

  <div class="modal fade" id="iosInstallApp" data-bs-backdrop="static"
       data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" translate>app.install.title</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <p translate>app.install.instruction</p>
              <br/>
              <br/>
              1. <span translate>app.install.first</span>&nbsp;<span
              class="icon icon24 safari-share"></span>
              <img class="img-fluid" src="/assets/img/instructions-pwa-install-ios.png"
                   alt="{{'app.install.image.tooltip' | translate}}"/>
              2. <span translate>app.install.second</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-secondary"
                  data-bs-dismiss="modal" translate>app.install.no
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
